<template>
  <Toast />
  <div Class="container p-mx-auto">
    <Dialog :header="$t('uyari')" v-model:visible="display">
      {{ message }}
    </Dialog>
    <Dialog
      v-model:visible="refer"
      modal
      :style="{
        width: '550px',
        background: '#FFFFFF',
        'box-shadow': ' 0px 0px 12px 2px rgba(0, 0, 0, 0.12)',
        'border-radius': '6px',
      }"
    >
      <template #header>
        <label style="font-weight: 700; font-size: 20px; color: #103660">
          {{
            !candidateSearch ? $t('newcandidate') : $t('addexistingcandidate')
          }}
        </label>
      </template>
      <Refer
        @candidateSearch="candidateSearch = $event"
        :webpage="false"
        :product="product"
        @hide-dialog="hideDailog"
      />
    </Dialog>

    <Dialog
      v-model:visible="apply"
      modal
      :style="{
        width: '550px',
        background: '#FFFFFF',
        'box-shadow': ' 0px 0px 12px 2px rgba(0, 0, 0, 0.12)',
        'border-radius': '6px',
      }"
    >
      <template #header>
        <label style="font-weight: 700; font-size: 20px; color: #103660">
          {{ $t('apply') }}
        </label>
      </template>
      <Apply :product="product" @hide-dialog="hideDailog" />
    </Dialog>

   

    <div style="display: flex; align-items: center; flex-direction: column">
      <div class="hero-wrapper">
        <Skeleton width="100%" height="200px" v-if="cmsData.length == 0" />
        <template v-else>
          <div class="hero-text">
            <h1 class="hero-title m-0">{{ header }}</h1>
            <p class="hero-sub">
              {{ header_subtext }}
            </p>
          </div>
          <img
            loading="lazy"
            width="236"
            height="236"
            :src="
              hero_img
                ? `${mediaURL}${hero_img}`
                : '/img/homepage_illustration.png'
            "
          />
        </template>
      </div>

      <div class="formm" v-if="cmsData.length != 0">
        <form @submit.prevent="handleLogin()" class="p-fluid">
          <div class="input-panel job-search-wrapper">
            <div class="p-inputgroup loc">
              <span class="p-inputgroup-addon" style="display: none">
                <i class="pi pi-user"></i>
              </span>

              <div class="p-float-label">
                <MultiSelect
                  display="chip"
                  id="location"
                  :loading="loading"
                  v-model="location"
                  :options="countries"
                  optionLabel="description"
                  :filter="true"
                  class="multiselect-custom"
                  :class="{ 'p-invalid': notvalid }"
                  :style="{
                    'border-color': notvalid ? errorBorderColor : '#DBDBDB',
                    'border-style': 'solid',
                    'border-width': '1px',
                    'border-radius': '6px',
                    'box-sizing': 'border-box',
                    width: '406px',
                    height: '47px',
                  }"
                >
                  <template #value="slotProps">
                    <div
                      class="country-item country-item-value flex items-center"
                      style="gap: 4px"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div class="d-flex align-items-center">
                        <i :class="`fi fi-${option.iso2.toLowerCase()}`"></i>
                        <div class="ml-2">{{ option.iso2 }}</div>
                      </div>
                    </div>
                  </template>
                  <template #option="slotProps">
                    <div
                      v-if="slotProps.option"
                      class="d-flex align-items-center"
                    >
                      <i
                        :class="`fi fi-${slotProps.option.iso2.toLowerCase()}`"
                      ></i>
                      <div class="ml-2">{{ slotProps.option.description }}</div>
                    </div>
                  </template>
                </MultiSelect>
                <i
                  style="
                    position: absolute;
                    top: 50%;
                    transform: translate(10px, -50%);
                    z-index: 99;
                    font-size: 130%;
                    color: #dbdbdb;
                  "
                  class="pi pi-map-marker"
                ></i>
                <label
                  style="
                    font-size: medium;
                    margin-left: 2rem;
                    font-family: 'Jost';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 17px;
                    color: #444444;
                  "
                  for="location"
                  :class="{ 'p-error': notvalid }"
                  :style="notvalid ? colorRed : ''"
                >
                  {{ notvalid ? $t('locationm') + '*' : $t('locationm') }}
                </label>
              </div>
            </div>
            <div class="divider"></div>
            <div class="p-inputgroup key">
              <span class="p-inputgroup-addon" style="display: none">
                <i class="pi pi-lock" />
              </span>
              <div class="p-float-label">
                <InputText
                  type="keyword"
                  id="keyword"
                  v-model="keyword"
                  @input="filterKey($event.target.value)"
                  :style="{
                    'border-color': '#DBDBDB',
                    'border-style': 'solid',
                    'border-width': '1px',
                    'border-radius': '6px',
                    'box-sizing': 'border-box',
                    width: '406px',
                    height: '47px',
                    'padding-left': '2.5rem',
                  }"
                  :class="{ 'p-invalid': notvalid }"
                />
                <i
                  style="
                    position: absolute;
                    top: 50%;
                    transform: translate(10px, -50%);
                    z-index: 99;
                    font-size: 130%;
                    color: #dbdbdb;
                  "
                  class="pi pi-search"
                ></i>
                <label
                  style="
                    font-size: medium;
                    margin-left: 2rem;
                    font-family: 'Jost';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 17px;
                    color: #444444;
                  "
                  for="keyword"
                  :class="{ 'p-error': notvalid }"
                  :style="notvalid ? colorRed : ''"
                >
                  {{ notvalid ? $t('keyword') + '*' : $t('keyword') }}
                </label>
              </div>
            </div>
            <div class="button-group">
              <Button type="submit" class="button-refer" label="Find Jobs" />
              <Button
                @click="getAllJobs"
                class="button-apply"
                label="All Jobs"
              />
            </div>
          </div>
        </form>
      </div>

      <!-- Skeleton for search form -->
      <div class="formm" v-if="cmsData.length == 0">
        <div class="p-fluid">
          <div class="input-panel job-search-wrapper">
            <div class="p-inputgroup loc">
              <div style="width: 406px; height: 47px; position: relative">
                <Skeleton width="100%" height="47px" borderRadius="6px" />
              </div>
            </div>
            <div class="divider"></div>
            <div class="p-inputgroup key">
              <div style="width: 406px; height: 47px; position: relative">
                <Skeleton width="100%" height="47px" borderRadius="6px" />
              </div>
            </div>
            <div class="button-group">
              <Skeleton width="124px" height="42px" borderRadius="4px" />
              <Skeleton width="124px" height="42px" borderRadius="4px" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="z-index: 2; position: relative">
      <div
        v-if="loading || jobOpenings.length === 0"
        class="d-flex w-100"
        style="
          gap: 8px;
          max-width: 1550px;
          margin-inline: auto;
          padding-block: 30px;
        "
      >
        <div
          v-for="item in 4"
          :key="item"
          style="
            flex: 1 0 25%;
            background: #ffffff;
            box-shadow: 7px 13px 14px -3px rgba(0, 0, 0, 0.11);
            border-radius: 12px;
            padding-block: 1rem;
            height: 278px;
          "
        >
          <div style="text-align: center; margin-bottom: 16px">
            <div
              style="
                border: 1px solid #e4e4e4;
                border-radius: 12px;
                width: 80px;
                height: 80px;
                margin: auto;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <Skeleton shape="circle" size="60px" />
            </div>
          </div>
          <div style="padding: 0 16px; text-align: center">
            <Skeleton
              width="70%"
              height="23px"
              class="mb-2"
              style="margin: 0 auto"
            />
            <Skeleton
              width="40%"
              height="21px"
              class="mb-2"
              style="margin: 0 auto"
            />
            <div
              style="
                background: #fff8ec;
                border-radius: 6px;
                max-width: 150px;
                width: 100%;
                height: 28px;
                margin: 0 auto 8px auto;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <Skeleton width="80%" height="14px" />
            </div>
            <div
              style="margin-bottom: 8px; display: flex; justify-content: center"
            >
              <Skeleton width="200px" height="21px" />
            </div>
            <div class="d-grid grid-columns-2 gap-3 px-4">
              <Skeleton width="100%" height="34px" borderRadius="4px" />
              <Skeleton width="100%" height="34px" borderRadius="4px" />
            </div>
          </div>
        </div>
      </div>
      <Carousel
        v-if="!loading && jobResult.length > 0"
        :value="jobResult"
        :numVisible="4"
        :numScroll="4"
        :responsiveOptions="responsiveOptions"
        circular
        :autoplayInterval="10000"
        :showIndicators="!isMobile()"
      >
        <template #item="slotProps">
          <div
            style="
              width: 100%;
              background: #ffffff;
              box-shadow: 7px 13px 14px -3px rgba(0, 0, 0, 0.11);
              border-radius: 12px;
              padding-block: 1rem;
            "
          >
            <div class="product-item-content">
              <div
                @click="detailJob(slotProps.data)"
                class="pointer"
                style="
                  text-align: center;
                  border: 1px solid #e4e4e4;
                  border-radius: 12px;
                  width: 80px;
                  height: 80px;
                  margin: auto;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  loading="lazy"
                  :src="logoURL + slotProps.data.company_logo"
                  :alt="slotProps.data.id"
                  class="product-image"
                />
              </div>
              <div>
                <h2
                  @click="detailJob(slotProps.data)"
                  class="pointer"
                  style="
                    text-align: center;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 23px;
                    color: #444444;
                    margin-bottom: 4px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 340px;
                    margin-inline: auto;
                  "
                >
                  {{
                    slotProps.data.company
                      ? slotProps.data.company.name
                      : slotProps.data.company_name
                  }}
                </h2>
                <h3
                  class="mt-0 w-100 slice pointer mx-auto"
                  style="
                    max-width: 200px;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 21px;
                    text-align: center;
                    color: #444444;
                    margin-bottom: 8px;
                  "
                  :title="slotProps.short_name"
                >
                  <router-link
                    style="text-decoration: none; color: #444444"
                    :to="{
                      name: 'jobDetail',
                      params: {
                        name: toSeoUrl(
                          `${
                            slotProps.data.company_name
                          }-${slotProps.data.short_name.replaceAll(' ', '_')}`
                        ),
                        id: slotProps.data.id,
                      },
                    }"
                  >
                    {{ slotProps.data.short_name }}
                  </router-link>
                </h3>
                <div
                  style="
                    background: #ffebcc;
                    border-radius: 6px;
                    max-width: 150px;
                    width: 100%;
                    height: 28px;
                    text-align: center;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 20px;
                    color: #fc6c2a;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 4px;
                    margin: auto;
                  "
                >
                  {{ `${$t('reward')}: ${formattedAmount(slotProps.data)}` }}
                </div>
                <div class="p-inputgroup flex-1">
                  <span class="p-inputgroup-addon">
                    <span
                      style="
                        width: 200px;
                        overflow: hidden; /* taşanları gizle */
                        white-space: nowrap; /* alt satıra hiç inme */
                        text-overflow: ellipsis;
                      "
                    >
                      <i class="pi pi-map-marker"></i>
                      {{
                        (slotProps.data.location_city_name
                          ? slotProps.data.location_city_name
                          : '') +
                        (slotProps.data.location_city_name &&
                        slotProps.data.location_country_name
                          ? '/'
                          : '') +
                        (slotProps.data.location_country_name
                          ? slotProps.data.location_country_name
                          : '')
                      }}
                    </span>
                  </span>
                </div>
                <div
                  :class="
                    slotProps.data.show_apply_button == -1 ||
                    slotProps.data.show_refer_button == -1
                      ? 'grid-columns-1 px-5'
                      : 'grid-columns-2 px-4'
                  "
                  class="d-grid gap-3"
                >
                  <Button
                    v-if="slotProps.data.show_refer_button == 1"
                    class="button-refer w-100 carousel-button"
                    @click="referToJob(slotProps.data)"
                    label="Refer"
                  />
                  <Button
                    v-if="slotProps.data.show_apply_button == 1"
                    class="button-apply w-100 carousel-button"
                    @click="applyToJob(slotProps.data)"
                    label="Apply"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </Carousel>
    </div>
    <div
      class="d-flex gap-3 mt-100px responsive-container"
      v-if="cmsData.length != 0"
    >
      <div class="d-flex flex-column gap-6">
        <div class="last-section-headers">
          <h2 class="m-0">{{ section_header }}</h2>
          <p class="mt-4">{{ section_header_subtext }}</p>
        </div>
        <div
          class="last-section-card d-flex p-justify-start gap-3"
          v-for="item in parsedListContent"
          :key="item.id"
        >
          <i class="fa-solid fa-circle-check"></i>
          <div class="d-flex p-flex-column gap-3">
            <span>{{ item.html_header }}</span>
            <p>
              {{ item.html_body }}
            </p>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center p-align-center">
        <img
          loading="lazy"
          width="520"
          height="575"
          :src="`${mediaURL}${section_img}`"
        />
      </div>
    </div>

    <!-- Skeleton for bottom section -->
    <div
      class="d-flex gap-3 mt-100px responsive-container"
      v-if="cmsData.length == 0"
    >
      <div class="d-flex flex-column gap-6" style="flex: 1">
        <div class="last-section-headers">
          <Skeleton width="70%" height="40px" class="mb-3" />
          <Skeleton width="90%" height="20px" />
        </div>
        <div
          class="last-section-card d-flex p-justify-start gap-3"
          v-for="item in 3"
          :key="item"
        >
          <div style="width: 24px; height: 24px">
            <Skeleton circle width="24px" height="24px" />
          </div>
          <div class="d-flex p-flex-column gap-3" style="flex: 1">
            <Skeleton width="40%" height="24px" />
            <Skeleton width="100%" height="56px" />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center p-align-center" style="flex: 1">
        <Skeleton width="520px" height="575px" borderRadius="8px" />
      </div>
    </div>
  </div>
</template>

<script>
// import { required } from "@vuelidate/validators";
// import { useVuelidate } from "@vuelidate/core";
import { post, get } from '../api/Services'

import { mapState, mapGetters } from 'vuex'
import { setItem, removeItem, getItem } from '../store/localStorage'
import { logoURL } from '../api/Services'
import Refer from '../components/Refer.vue'
import Apply from '../components/Apply.vue'
// import { router } from "../router.js";

export default {
  name: 'Home',
  data() {
    return {
      candidateSearch: false,
      responsiveOptions: [
        {
          breakpoint: '1285px',
          numVisible: 3,
          numScroll: 3,
        },
        {
          breakpoint: '991px',
          numVisible: 2,
          numScroll: 2,
        },
        {
          breakpoint: '767px',
          numVisible: 1,
          numScroll: 1,
        },
      ],
      errorBorderColor: '#B00020',
      colorRed: { color: '#B00020' },
      location: '',
      keyword: '',
      user: {},
      topsize: false,
      jobOpenings: [],
      submitted: false,
      countries: [],
      cmsData: [],
      header: '',
      header_subtext: '',
      section_header: '',
      section_header_subtext: '',
      section_list: [],
      section_img: '',
      jobResult: [],
      mediaURL: process.env.VUE_APP_MEDIA_URL,
      homepageMode: 'home',
      logoURL: logoURL,
      refer: false,
      loading: true,
      apply: false,
      product: {},
      notvalid: false,
      filters: {},
      hero_img: '',
    }
  },

  async created() {
    this.cms()
    this.getCountries()
    if (this.account.loggeduser) {
      await this.fetchUserRole()
    }
    this.user.userId = this.account.loggeduser ? this.account.loggeduser.id : -1
    this.user.sqlId = 3
    let countryId = -1

    if (this.location) {
      this.location.map((each) => {
        if (countryId == '') {
          countryId = countryId + each.id
        }
      })
    }

    let parameters = [
      // {
      //   parameter_name: "pin_user_id",
      //   parameter_value: -1,
      // },
      { parameter_name: 'pin_job_opening_id', parameter_value: -1 },
      { parameter_name: 'pin_city_id', parameter_value: -1 },

      { parameter_name: 'pin_country_id', parameter_value: -1 },
      { parameter_name: 'pin_company_id', parameter_value: -1 },
      { parameter_name: 'pin_status_id', parameter_value: 1 },
      { parameter_name: 'pin_assigned_company_user_id', parameter_value: -1 },
      { parameter_name: 'pin_assigned_internal_user_id', parameter_value: -1 },
      { parameter_name: 'piv_search_text', parameter_value: '' },
      { parameter_name: 'pin_recruitment_type_id', parameter_value: -1 },
      { parameter_name: 'pin_job_type_id', parameter_value: -1 },
      { parameter_name: 'pin_is_remote', parameter_value: -1 },
      { parameter_name: 'piv_posted_after_date', parameter_value: '' },
    ]
    this.user.parameters = JSON.stringify(parameters)

    post('Commons/Executer', this.user)
      .then((data) => {
        if (data) {
          this.jobOpenings = data
          this.jobResult = data
          setItem('jobOpenings', data)
        }
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    isMobile() {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    },
    async cms() {
      const parameters = [
        {
          parameter_name: 'piv_page_path',
          parameter_value: '/',
        },
        {
          parameter_name: 'piv_tag_group',
          parameter_value: 'companies',
        },
      ]

      await post('/Commons/Executer', {
        sqlId: 76,
        parameters: JSON.stringify(parameters),
      })
        .then((data) => {
          this.cmsData = data
          console.log(this.cmsData)
          this.cmsData.map((item) => {
            switch (item.tag) {
              case 'header':
                this.header = item.html_content
                break
              case 'header_subtext':
                this.header_subtext = item.html_content
                break
              case 'section_header':
                this.section_header = item.html_content
                break
              case 'section_header_subtext':
                this.section_header_subtext = item.html_content
                break
              case 'section_list':
                if (item.list_content !== '[null]') {
                  this.section_list = JSON.parse(item.list_content).sort(
                    (a, b) => a.order_id - b.order_id
                  )
                }
                break
              case 'section_img':
                this.section_img = item.file_path
                break
              case 'hero_img':
                this.hero_img = item.file_path
                break
              default:
                break
            }
          })
        })
        .catch((err) => console.log(err))
    },
    async getCountries() {
      this.loading = true
      let parameters = []

      await post('/Commons/Executer', {
        sqlId: 71,
        parameters: JSON.stringify(parameters),
      })
        .then((data) => {
          this.countries = data
        })
        .catch((err) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: err.message,
            life: 3000,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchUserRole() {
      await get('Users/Role')
    },
    searchRemove(id) {
      this.location = this.location.filter((item) => item.id !== id)
    },
    hideDailog() {
      this.refer = false
      this.apply = false
    },
    applyToJob(data) {
      const loggedIn = JSON.parse(getItem('loggeduser'))
      if (loggedIn) {
        this.product = { ...data }
        this.apply ? (this.apply = false) : (this.apply = true)
      } else {
        this.$router.push({
          name: 'login',
          query: { redirect: this.$route.fullPath },
        })
      }
    },
    referToJob(data) {
      const loggedIn = JSON.parse(getItem('loggeduser'))
      if (loggedIn) {
        this.product = { ...data }
        this.refer ? (this.refer = false) : (this.refer = true)
      } else {
        this.$router.push({
          name: 'login',
          query: { redirect: this.$route.fullPath },
        })
      }
    },
    getStarted() {
      this.$router.push({ name: 'getStarted' })
    },
    detailJob(data) {
      setItem('jobDetail', data)
      this.$router.push({
        name: 'jobDetail',
        params: {
          name: this.toSeoUrl(
            `${data.company_name}-${data.short_name.replaceAll(' ', '_')}`
          ),
          id: data.id,
        },
      })
    },

    toSeoUrl(text) {
      // Küçük harfe çevir
      let seoText = text.toLowerCase()

      // Türkçe karakterleri İngilizce karşılıklarına çevir
      const map = {
        ç: 'c',
        ğ: 'g',
        ı: 'i',
        ö: 'o',
        ş: 's',
        ü: 'u',
        Ç: 'C',
        Ğ: 'G',
        İ: 'I',
        Ö: 'O',
        Ş: 'S',
        Ü: 'U',
      }

      seoText = seoText.replace(/[çğışüö]/g, (match) => map[match] || match)

      // Özel karakterleri ve boşlukları '-' ile değiştir
      seoText = seoText.replace(/[^a-z0-9]+/g, '-')

      // Başlangıç ve bitişteki '-' karakterlerini kaldır
      seoText = seoText.replace(/^-+|-+$/g, '')

      return seoText
    },

    home() {
      this.$router.push({ name: 'home' })
    },
    login() {
      this.$router.push({ name: 'login' })
    },
    toggle() {
      if (this.topsize == false) {
        this.topsize = true
      } else {
        this.topsize = false
      }
    },
    signUp() {
      this.isLogin = false
    },
    isRequired(value) {
      if (value && value.trim()) {
        return true
      }

      return 'This is required'
    },

    getAllJobs() {
      if (getItem('search-parameter')) {
        removeItem('search-parameter')
      }
      this.$router.push({ name: 'jobs' })
    },

    handleLogin() {
      this.submitted = true
      if (!this.location && !this.keyword) {
        this.message = 'No Valid'
        this.notvalid = true
        return
      }

      this.loading = true
      this.user.userId = -1
      this.user.sqlId = 3
      let countryId = -1
      if (this.keyword || this.location) {
        setItem('search-parameter', {
          location: this.location,
          keyword: this.keyword,
        })
      }
      if (this.location) {
        this.location.map((each) => {
          if (countryId == '') {
            countryId = countryId + each.id
          } else {
            countryId = countryId + ',' + each.id
          }
        })
      }

      let parameters = [
        // {
        //   parameter_name: "pin_user_id",
        //   parameter_value: -1,
        // },
        { parameter_name: 'pin_job_opening_id', parameter_value: -1 },
        { parameter_name: 'pin_city_id', parameter_value: -1 },

        {
          parameter_name: 'pin_country_id',
          parameter_value: countryId ? countryId : -1,
        },
        { parameter_name: 'pin_company_id', parameter_value: -1 },
        { parameter_name: 'pin_status_id', parameter_value: 1 },
        { parameter_name: 'pin_assigned_company_user_id', parameter_value: -1 },
        {
          parameter_name: 'pin_assigned_internal_user_id',
          parameter_value: -1,
        },
        { parameter_name: 'piv_search_text', parameter_value: this.keyword },
        { parameter_name: 'pin_recruitment_type_id', parameter_value: -1 },
        { parameter_name: 'pin_job_type_id', parameter_value: -1 },
        { parameter_name: 'pin_is_remote', parameter_value: -1 },
        { parameter_name: 'piv_posted_after_date', parameter_value: '' },
      ]
      this.user.parameters = JSON.stringify(parameters)
      post('Commons/Executer', this.user).then((data) => {
        if (data) {
          setItem('jobOpenings', data)
          this.filters.location = this.location
          this.filters.keyword = this.keyword
          setItem('filters', this.filters)
        }
      })
      this.$router.push({ name: 'jobs' })
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
  },
  components: {
    Apply: Apply,
    Refer: Refer,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    ...mapGetters(['formattedAmount']), // formattedAmount getter'ını alıyoruz
    parsedListContent() {
      try {
        return this.section_list.length > 0 ? this.section_list : []
      } catch (e) {
        console.error('Error parsing list_content:', e)
        return []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../App.scss';

.error-feedback {
  color: red;
}

.pages-body .topbar .topbar-left img {
  height: 5rem;
}

.p-inputgroup {
  display: flex;
  align-items: stretch;
  width: 100%;
  flex-direction: column;
}

.p-button-label {
  font-family: 'Jost';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
}

.google-signup-buttons {
  height: 62px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 4px 37px #0000001c;
  border-radius: 6px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 18rem;
  float: left;
}

.signup-text {
  text-align: center;
  font-family: 'Jost';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #696969;
  padding-left: 1rem;
}

.linkdin-signup-buttons {
  height: 62px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 4px 37px #0000001c;
  border-radius: 6px;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  width: 18rem;
  margin-left: 22rem;
}

.login-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: #ffffff;
}

::v-deep(.p-carousel-item) {
  padding: 0 6px;
}

::v-deep(.p-carousel-items-content) {
  margin: auto 0;
  padding-block: 30px 30px !important;

  @media (max-width: 1196px) {
    padding-right: 75px;
  }

  @media (max-width: 767px) {
    padding: 0px;
    margin: 0;
  }
}

::v-deep(.p-radiobutton-icon) {
  transform: translateZ(0) scale(1, 1) translate(-3.5%, -5%);
}
.last-section-headers {
  h2 {
    font-weight: 700;
    font-size: 40px;
    color: rgba(68, 68, 68, 1);
  }
  p {
    font-weight: 400;
    font-size: 20px;
    color: rgba(68, 68, 68, 1);
  }
}

.p-multiselect {
  width: 18rem;
}

::v-deep(.multiselect-custom) {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 1rem;
    padding-bottom: 0.25rem;
  }

  .country-item-value {
    padding: 0.25rem 0.5rem;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: #e4e4e4;
    color: #212529;
    border-radius: 6px;

    img.flag {
      width: 17px;
    }
  }
}

.country-item {
  display: flex;
  align-items: center;
  padding: 1rem;
}

@media screen and (max-width: 640px) {
  .p-multiselect {
    width: 100%;
  }
}

::v-deep(.p-multiselect-items-wrapper) {
  li {
    color: #fc6c2a;
    background: #fc6d2a11;
  }
}

::v-deep(.p-carousel-container) {
  width: 100%;

  @media screen and (max-width: 1199px) {
    padding-inline: 0px;
  }

  .p-carousel-next {
    width: 44px;
    height: 44px;
    background: #ffebcc;
    color: #015cac;

    @media screen and (max-width: 991px) {
      width: 25px;
      height: 25px;
    }
  }

  .p-carousel-prev {
    width: 44px;
    height: 44px;
    background: #ffebcc;
    color: #015cac;

    @media screen and (max-width: 991px) {
      width: 25px;
      height: 25px;
    }
  }
}

::v-deep(.p-carousel-indicators) {
  align-items: center;

  button {
    width: 9px !important;
    height: 9px !important;
    border-radius: 50% !important;
  }
}

::v-deep(.p-highlight) {
  button {
    width: 13px !important;
    height: 13px !important;
    background: #fc6c2a !important;
    border-radius: 50% !important;
  }
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.last-section-card {
  min-height: 113px;
  padding: 1rem;
  line-height: 1;
  box-shadow: 10px 24px 54px 0px rgba(51, 51, 51, 0.03);
  border-radius: 10px;
  i {
    font-size: 24px;
    color: #fc6c2a;
  }
  span {
    font-weight: 500;
    font-size: 24px;
    color: rgba(68, 68, 68, 1);
    line-height: 28px;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    color: rgba(68, 68, 68, 1);
    line-height: 28px;
  }
}
::v-deep(.card) {
  border: 0;
  background: #ffffff;
  box-shadow: 10px 24px 54px rgba(51, 51, 51, 0.03);
  border-radius: 10px;
  max-width: 400px;
  width: 100%;
  margin-bottom: 16px !important;
}

::v-deep(.p-carousel-items-container) {
  @media (max-width: 767px) {
    gap: unset;
  }
}

.p-inputgroup-addon {
  border: 0;
  gap: 8px;

  span {
    font-weight: 400;
    font-size: 13px;
    line-height: 21px;
    text-align: center;
    color: #444444;
  }
}
.formm {
  box-shadow: 0 6px 15px rgba(1, 92, 172, 0.2);
}
.button-refer {
  &:not(.carousel-button) {
    width: 124px;
    height: 42px;
  }
  background-color: #fc6c2a !important;
  color: white;
  border: 1px solid #fc6c2a;
  transition: all 0.3s ease-in-out;

  &:disabled {
    opacity: 0.5;
    user-select: none;
    background-color: #fc6c2a !important;
    color: white !important;
    border: 1px solid #fc6c2a !important;
  }

  &:hover {
    background-color: white !important;
    color: #fc6c2a;
    border: 1px solid #fc6c2a;
  }
}

.button-apply {
  &:not(.carousel-button) {
    width: 124px;
    height: 42px;
  }

  &:disabled {
    background-color: #015cac !important;
    color: white !important;
    border: 1px solid #015cac !important;
    opacity: 0.5;
    user-select: none;
  }

  background-color: #015cac;
  color: white;
  border: 1px solid #015cac;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: white;
    color: #015cac;
    border: 1px solid #015cac;
  }
}
.responsive-container {
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
</style>
